import { ForestProductTradingDashboard as TradingDashboard } from '../../../components/ForestProduct';

export function ForestProductTradingDashboard() {
  return <TradingDashboard />;
}
